<template>
  <div class="container-fluid" :style="loginStyle">
    <div class="row">
      <div class="col-lg-2 col-md-2 col-sm-2 col-2"></div>
      <div class="col-lg-8 col-md-8 col-sm-8 col-8">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="signup">Login</div>
            <div class="getstarted">Welcome! Login for seamless, hyperlocal environment data.</div>
            <form>
              <div class="form-group">
                <label>Email Address</label>
                <input
                  v-model="email"
                  type="email"
                  class="form-control input-lg"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  required
                />
              </div>
              <div class="form-group">
                <label>Password</label>
                <input
                  v-model="password"
                  type="password"
                  class="form-control input-lg"
                  id="exampleInputPassword1"
                  placeholder="* * * * * * * *"
                  required
                />
              </div>
              <div @click="login" class="btn btn-primary signupbtn pt-2 mt-3">Login</div>
              <div class="pt-3" v-if="invalidUser==1">
                <p class="invalid">You are not allowed to login</p>
              </div>
            </form>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-6 d-none d-sm-block img-container">
            <img src="../assets/Group 4.png" class="img-fluid" alt="group 4 img" />
          </div>
        </div>
      </div>

      <div class="col-lg-2 col-md-2 col-sm-2 col-2"></div>
    </div>
  </div>
</template>
<script>
// import axios from 'axios';
import { AUTH_REQUEST } from "../store/actions/auth";

export default {
  data() {
    return {
      email: "",
      password: "",
      hidePassword: true,
      loginStyle: {
        backgroundColor: "white",
      },
      invalidUser: 0,
    };
  },
  methods: {
    login() {
      const email = this.email;
      const password = this.password;
      this.$store
        .dispatch(AUTH_REQUEST, { email, password })
        .then(async () => {
          const roleId = parseInt(JSON.parse(localStorage.getItem("user")).roleId);
          if(roleId == 3)
          {
          await this.$router.push("/home");
          }
          else if(roleId == 4){
          await this.$router.push("/apidb");  
          }
          else {
          await this.$router.push("/cust"); 
          }
        })
        .catch((error) => {
          // alert("ERROR");
          this.invalidUser = 1;
          console.log("Auth error", error);
        });
    },
  },
};
</script>
<style scoped>
.signup {
  font-family: Ubuntu;
  font-weight: 700;
  font-size: 38px;
  color: #3b3b3b;
  text-align: left;
  margin-top: 25%;
}
.getstarted,
.invalid {
  opacity: 0.7;
  font-family: Ubuntu;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
  line-height: 24px;
}
label {
  font-family: Ubuntu;
  font-weight: 400;
  font-size: 12px;
  color: #606060;
  padding-left: 5px;
  padding-right: 5px;
}
.signupbtn {
  background: #2295c8;
  border-radius: 30px;
  width: 108px;
  height: 44px;
  font-family: ubuntu;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
  line-height: 20px;
  border: none;
}

.signupbtn:hover {
  background: #2295c8;
}
.img-container {
  margin-top: 20%;
  width: 100%;
}
.form-group > label {
  position: relative;
  left: 19px;
  top: 15px;
  background: white;
}
.input {
  padding-top: 2px;
  font-family: ubuntu;
  font-weight: 300;
  color: white;
}
@media only screen and (max-width: 600px) {
}
</style>
